
import {ParseTime} from "../../utils/time"
import {Api} from "../../utils/api"
import Search from 'vux/src/components/search/index.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'

import NotFound from '../../components/NotFound'
import {Fetch} from "../../utils/storage"

export default {
name: 'meeting-list',

filters: {
ParseEndAt(val) {
return ParseTime(val, '{y}-{m}-{d}')
}
},
data () {
return {
MeetingList:[],
Page: 1,
Limit:999,
SearchValue: '',
IsShowNotFound:false,
MeetingTypeIndex: 0
}
},
components: {
NotFound,
Tab,
TabItem,
Search
},
created () {
this.FetchMeetingList()
},
methods: {
async FetchMeetingList() {
try {
let reqData = {
Data:{
Visible:1,
Status:'verified',
EnrollStartAt: new Date()
},
Limit:this.Limit,
Offset: (this.Page - 1) * this.Limit,
Order:'index',
Select:'id,tittle,head_img,holding_city,start_at,enroll_start_at,note,meeting_type',
Preloads:[
{Column:'SubMeetings', Select:'id,meeting_id'}
]

}
switch (this.MeetingTypeIndex) {
case 0:
break;
case 1:
reqData.Data.MeetingType = 'conference'
break;
case 2:
reqData.Data.MeetingType = 'training'
break;
}
let res = await Api('GetMeetingList', reqData)
this.MeetingList = (res.data && res.data.List) ? res.data.List : []
if (this.MeetingList.length <1) this.IsShowNotFound = true
}catch(err){
console.log(err)
}
},
async handleSearchSubmit() {
if(!this.SearchValue) {
return
}
this.$refs.search.setBlur()
let res = await Api('SearchMeeting', {
Where:{
Visible:1,
EnrollStartAt: new Date()
},
Name: this.SearchValue,
Limit:this.Limit,
Offset: (this.Page - 1) * this.Limit,
Order:'index',
Select:'id,tittle,head_img,holding_city,start_at,enroll_start_at,note',
Preloads:[
{Column:'SubMeetings', Select:'id,meeting_id'}
]
})
if (res.data.List) {
this.MeetingList = res.data.List
}else {
this.$vux.confirm.show({
theme: 'ios',
content: '<span style="font-size:20px">抱歉没有找到您搜索的会议！</span>',
showCancelButton:false,
})
this.SearchValue = ''
}
},
handleSearchCancel() {
this.Page = 1
this.SearchValue = ''
this.FetchMeetingList()
},
async onItemClick (index) {
this.MeetingTypeIndex = index
await this.FetchMeetingList()
},
}
}
